// src/contexts/useAppStore.js

import { create } from 'zustand';

const useAppStore = create((set) => ({
  isSidebarOpen: false,
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
}));

export default useAppStore;
